import { render, staticRenderFns } from "./ProductSertificate.vue?vue&type=template&id=f0efe97e"
import script from "./ProductSertificate.vue?vue&type=script&lang=js"
export * from "./ProductSertificate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports